import React from 'react';
import { ReactSortable } from "react-sortablejs";


class ProjetListFieldsComponent extends React.Component {
	constructor(props) {
		super(props);

		if ( props.value ) {
			for ( let i = 0; i < props.value.length; i++ ) {
				if ( !props.value[i].hasOwnProperty('id') )
					props.value[i].id = uniqid();
			}
		}

		this.state = { 
			items: props.value ?? [],
		};
	}

	update() {
		updateFields(this.state.items);
	}

	addElement() {
		let items = this.state.items;
		items.push({
			id: uniqid('tmp'),
			nom: '',
			required: false,
			invisible: false,
		});
		this.setState({ items: items });
		this.update();
	}

	removeElement(index) {
        if ( window.confirm('Voulez-vous supprimer ce champ ?') ) {
            let items = this.state.items;
            items.splice(index, 1);
            this.setState({ items: items });
            this.update();
        }
	}

	changeNom(value, index) {
		let items = this.state.items;
		items[index].nom = value;
		this.setState({ items: items });
		this.update();
	}

	changeRequired(input, index) {
		let items = this.state.items;
		items[index].required = input.checked;
		this.setState({ items: items });
		this.update();
	}

	changeInvisible(input, index) {
		let items = this.state.items;
		items[index].invisible = input.checked;
		this.setState({ items: items });
		this.update();
	}

	renderItem(item, index) {
		return (<div key={item.id} className="row align-items-center gx-2 mt-2">
            <div className="col-auto px-1 align-self-stretch d-flex align-items-center">
                <i className="grabber bi bi-grip-vertical px-2"></i>
			</div>
            <div className="col-auto">
                <input className="form-control" value={item.nom} onChange={e => this.changeNom(e.target.value, index)} required />
            </div>
            <div className="col-auto">
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id={'required' + item.id} onChange={e => this.changeRequired(e.target, index)} checked={item.required ?? false} />
                    <label className="form-check-label" htmlFor={'required' + item.id}>requis</label>
                </div>
            </div>
			<div className="col-auto">
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id={'invisible' + item.id} onChange={e => this.changeInvisible(e.target, index)} checked={item.invisible ?? false} />
                    <label className="form-check-label" htmlFor={'invisible' + item.id}>invisible</label>
                </div>
            </div>
			<div className="col-auto">
                <button type="button" className="btn-close" onClick={e => this.removeElement(index)}></button>
            </div>
		</div>);
	}

	render() {
		let items;
		if ( this.state.items.length ) {
			items = this.state.items.map( ( item, index ) => {
				return this.renderItem(item, index, null);
			});
		}

		return (
			<>
				<ReactSortable
					list={this.state.items}
					setList={(newState) => { this.setState({ items: newState }, () => this.update() ) } }
					animation={150}
					handle=".grabber"
					ghostClass="_moving"
					fallbackOnBody={true}
					swapThreshold={0.65}
				>
					{items}
				</ReactSortable>
				<button type="button" className="btn btn-secondary mt-3" onClick={e => this.addElement()}>Ajouter un champ</button>
			</>
		);
	}
}

export default ProjetListFieldsComponent;